const user = {
  support: {
    viewtitle: 'Support',
    newticket: 'New Ticket',
    submitticket: 'Submit Ticket',
    submitreply: 'Submit Reply',
    yourtickets: 'Your Tickets',
    ticket: {
      tag: 'Area',
      title: 'Title',
      message: 'Message',
      error: {
        tag: 'Please choose an Area',
        title: 'Please provide a Title',
        text: 'Please provide a Message'
      },
      placeholder: {
        tag: '-- Please select an option --',
        title: 'Title of your support request',
        text: 'Enter your message'
      },
      detail: {
        created: 'Created',
        title: 'Title',
        state: 'State',
        tag: 'Area',
        reply: 'Reply',
        conversationtitle: 'The conversation',
        formtitle: 'Reply to the conversation'

      }
    },
    tickettitle: 'Ticket Title',
    created: 'Created',
    state: 'State',
    tag: 'Area',
    cancelticket: 'Cancel',
    notickets: 'Our monkeys can not find any tickets. Feel free to submit one.',
    showopen: 'Only show open tickets'
  },

  profile: {
    viewtitle: 'Profile'
  },

  settings: {
    viewtitle: 'Settings',
    reports_title: 'Report-Settings',
    intro: 'Make your work transparent to your customer by sending customized monthly reports.',
    reports_customized: 'Customize report',
    reports_primary_color: 'Primary Color',
    reports_contrast_color: 'Contrast Color',
    reports_mail_content: 'Mail Content',
    reports_mail_subject: 'Subject',
    reports_mail_styles: 'Mail Styles',
    reports_template_help: '<p>You can use the Markdown formatting language to create the content. You can use the following placeholders to add data to your reports:</p><pre>{site} <span class="comment">// URL of Website</span><br/><br/>{contactperson} <span class="comment">// Name of contact person defined in the site details</span><br/><br/>{amount-extension-updates} <span class="comment">// Number of Extension Updates installed</span><br/><br/>{amount-core-updates} <span class="comment">// Number of Core Updates installed</span><br/><br/>{amount-backups} <span class="comment">// Number of done Backups </span><br/><br/>{amount-tests} <span class="comment">// Number of done Backup-Tests started </span><br/><br/>{amount-tests-successfull} <span class="comment">// Number of successfull Backup-Tests </span><br/><br/>{uptime-percentage} <span class="comment">// Site availability in percentage</span><br/><br/>{core-update-list} <span class="comment">// Detailed list of core updates</span><br/><br/>{extension-update-list} <span class="comment">// Detailed list of applied extension updates</span><br/><br/>{year} <span class="comment">// year of report</span><br/><br/>{month} <span class="comment">// month of report</span><br/><br/>{last-day-of-month} <span class="comment">// last day of month of report</span></pre>'
  },
  dpainfo: {
    viewtitle: 'GDPR'
  },
  payment: {
    viewtitle: 'Payment',
    addinformation: 'Enter Credit Card Details',
    addsepainformation: 'Enter Bank Account Information',
    nopaymentinformationtitle: 'Missing Payment information',
    nopaymenttext: 'Your monkey needs a lot of bananas to stay productive - add payment information, so that the monkey can buy some nice Bio Bananas. Of course we will handle your data with care.',
    nocreditcardtitle: 'Missing Credit Card Information',
    nocreditcard: 'Seems like you did not entered any Credit Card information yet.',
    addcreditcard: 'Add Credit Card information',
    validpaymenttitle: 'Thank you so much',
    validpayment: 'Nice, you already entered valid payment informationen. No worries, we surely handle them with care.',
    validcreditcardtitle: 'We have valid Credit Card informationen from you',
    validcreditcard: '',
    updatecard: 'Update Card',
    updatesepa: 'Update Bank Account',
    sepaallowed: 'We prefer Credit Card payment but if it is easier for you, you can add your bank account information easily.',
    addsepa: 'Add Bank Account',
    sepanote: 'By providing your IBAN and confirming this payment, you are authorizing BackupMonkey UG and Stripe, our payment service provider, to send instructions to your bank to debit your account and your bank to debit your account in accordance with those instructions. You are entitled to a refund from your bank under the terms and conditions of your agreement with your bank. A refund must be claimed within 8 weeks starting from the date on which your account was debited.',
    submitsepa: 'Submit Sepa Information',
    submitcard: 'Submit Card Details',
    differentpaymentnote: 'No Credit Card? We will try to find a solution for you. \n' +
      'Just send us a <a href="mailto:hello@backupmonkey.io">mail.</a>',
    intro: 'To feed our hard-working monkeys we need a lot of bananas of course. \n' +
      'To finance this we need your credit card details. Thank you very much for your trust.',
    sepaintro: 'To feed our hard-working monkeys we need a lot of bananas of course. \n' +
      'To finance this we need your bank account information. Thank you very much for your trust.',
    removecc: 'Remove Card',
    removesepa: 'Remove Sepa',
    setasdefault: 'Set as default',
    type: 'Type',
    last4: 'Last 4',
    actions: '',
    creditcard: 'Credit Card',
    bankaccount: 'Bank Account'
  },

  paymentaddcard: {
    viewtitle: 'Add Credit Card'
  },

  paymentaddsepa: {
    viewtitle: 'Add Bank Account',
    error: {
      invalid_owner_name: 'Account holder name must be at least 3 characters long.'
    }
  },
  invoices: {
    viewtitle: 'Invoices',
    costscurrent: 'Current Balance:',
    titlelist: 'Invoices',
    number: 'Invoice No.',
    total: 'Total',
    site: 'Sites',
    plan: 'Automatisation',
    backuptest: 'Backup test',
    created: 'Date'
  },
  actions: '',
  sites: '# Sites',
  paymentvalid: 'Payment',
  profilevalid: 'Profile',
  confirmed: 'Confirmed',
  confirmedno: 'Not Confirmed',
  confirmedyes: 'Is Confirmed',
  acompany: 'Company',
  afirstname: 'Firstname',
  alastname: 'Lastname',
  street: 'Street',
  city: 'City',
  homepage: 'Homepage',
  telephone: 'Telefon',
  country: 'Country',
  vatid: 'Company',
  remainingfreedays: 'Remaining free days',
  avatid: 'VatId',
  vatidvalidcheckdate: 'VatId Checkdate',
  valid: 'Valid',
  invalid: 'Invalid',
  stripeid: 'Stripe Id',
  stripeemail: 'Stripe E-Mail',
  vatidisvalid: 'VatId Valid?',
  vatidisvalidyes: 'Is valid',
  vatidisvalidno: 'Is invalid',
  paymentsection: 'Payment',
  accountsection: 'Account',
  basesection: 'Basic Info',
  impersonate: 'Impersonate',
  destroyheading: '👋 Time to say goodbye!',
  destroywarning: 'At this point we would like to thank you very much for your trust in our service. If you have any further questions, please do not hesitate to contact us at any time.\n' +
    '\n' +
    'By deleting the account, all personal data that is not required for legal reasons will be deleted. ',
  stopdestroyadmin: 'Cancel Removement',
  stopdestroyuser: 'Cancel Removement',
  confirmdestroy: 'Delete Now',
  userdestroyresults: '<p>If you remove the user, you will be able to use the service till the end of the month. You have paid for it so you get, what you have paid for.<br> We will send you an invoice if needed and delete you account at the beginning of the next month. <br>So sorry to see you going, maybe we will see later.</p>',
  serviceenabled: 'Enabled',
  search: 'Search: names, email, company',
  remove: 'Remove',
  firstname: 'Firstname',
  lastname: 'Lastname',
  email: 'E-Mail',
  fetchdata: 'Fetching Data',
  predelete: 'PreDeleted',
  adminlist: {
    viewtitle: 'Userlist'
  },
  autoupdate: {
    viewtitle: 'Automated Extension Updates',
    intro: 'If enabled, we will start a backup of your websites each time before automated extension updates are installed. This global setting can be overridden by page-specific settings.',
    note: 'Please note that automatically triggered backups can create a large number of backup archives, which fill up storage space accordingly.',
    backupbefore: 'Enable automatic backups before automated extension updates are installed.'
  },
  monitoringsettings: {
    viewtitle: 'Site Monitoring',
    intro: 'Our monkeys are constantly monitoring the availability of your site. If a site goes down, we wait for a couple of minutes to see if it comes up again - and once that moment is over, you will be notified right away. This setting allows you to configure that waiting threshold. Hint: you can also override this setting per site in the site detail view.',
    label: 'Downtime notification waiting time'
  }
}

export default user
